import { render } from "./ratingView.vue?vue&type=template&id=19fbe096&scoped=true"
import script from "./ratingView.vue?vue&type=script&lang=js"
export * from "./ratingView.vue?vue&type=script&lang=js"

import "./ratingView.vue?vue&type=style&index=0&id=19fbe096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fbe096"]])

export default __exports__